<template>
    <div>

        <b-form>
                <div class="animated fadeIn">
                    <b-card>
                    <b-row>
                        <b-col md="12">
                            <b-form>
                            <b-form-group
                            description=""
                            label="Assunto"
                            label-for="subject"
                            :label-cols="3"
                            label-align="left"
                            :horizontal="true">
                            <b-form-textarea
                                id="textarea"
                                v-model="selectedItem.subject"
                                placeholder=""
                                rows="3"
                            ></b-form-textarea>
                            </b-form-group>          
                            </b-form>
                        </b-col>
                    </b-row>                   
                    <b-row>
                        <b-col md="12">
                            
                            <b-form>
                            <b-form-group
                            description=""
                            label="Período"
                            label-align="left"
                            label-for="startDate"
                            :label-cols="3"
                            :horizontal="true">
                            <table>
                                <tr>
                                <td><date-picker v-model="selectedItem.startDate" :config="datePickerOptions" :class="startDateClass"></date-picker></td>
                                <td><date-picker v-model="selectedItem.endDate" :config="datePickerOptions" :class="endDateClass"></date-picker></td>
                                </tr>
                            </table>
                            </b-form-group>          
                            </b-form>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="12">
                            <b-form>
                                <b-form-group
                                description=""
                                label=""
                                label-for="isOptional"
                                :label-cols="3"
                                :horizontal="true">

                                <input id="isOptional" type="checkbox" value="" v-model="selectedItem.isOptional"> Evento opcional
                            </b-form-group>  

                            </b-form>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="12">
                            <b-form>
                            <b-form-group
                            description=""
                            label="Notas"
                            label-for="notes"
                            :label-cols="3"
                            label-align="left"
                            :horizontal="true">
                            <b-form-textarea
                                id="textarea"
                                v-model="selectedItem.notes"
                                placeholder=""
                                rows="3"
                            ></b-form-textarea>
                            </b-form-group>          
                            </b-form>
                        </b-col>
                    </b-row>     
                    </b-card>
                    <div slot="footer" class="text-right">
                        <b-button variant="github" class="mr-1 btn-brand" @click="save()"><i class="fa fa-check"></i><span>Salvar Data de Evento</span></b-button>
                    </div>
                </div>
            </b-form>

           
            
    </div>  

</template>


<script>
import Vue from 'vue'
import axios from "axios";
import MaskedInput from 'vue-text-mask'
import { Switch as cSwitch } from '@coreui/vue'
  
/* DataTimePicker */
import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

/* Toast */
import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */

export default {
    name: 'eventDateComponent',
    props: {
       item: {},
       companyId: 0
    },
    components: {
      MaskedInput,
      cSwitch,
      datePicker
    },
    data: () => {
        return {   
           
            startDateClass: '',
            endDateClass: '',
            
            datePickerOptions: {
                format: 'DD/MM/YYYY HH:mm',
                useCurrent: false,
            },
            
            franchiseGroupDDL: [],
            eventTypeDDL: [], 

            eventTypeClass: '',
            nameClass: '',
                        
            switchLabelIcon: {
                dataOn: '\u2713',
                dataOff: '\u2715'
            }
        }
    },
    computed: {
        selectedItem() {
            return this.item
        },

        selectFranchiseGroupDDL: function() {
          var list = [...this.franchiseGroupDDL]
          list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
          list.unshift({ value: '0' , text: '-' })
          return list
      }
    },
    methods: {
        save() {
            let containsError = false

            if(!this.selectedItem.startDate || this.selectedItem.startDate <= 0) {
                this.startDateClass = "is-invalid"
                containsError = true
            }
            else {
                this.startDateClass = ""
            }

            if(!this.selectedItem.endDate || this.selectedItem.endDate <= 0) {
                this.endDateClass = "is-invalid"
                containsError = true
            }
            else {
                this.endDate = ""
            }
            
            if(!containsError) {                
                this.saveItem(this.selectedItem);
            }
        },
        
        async saveItem(currentItem) {

            var s = this;
            var postData = {...currentItem};

            
            postData["uid"] = this.$store.state.currentUser.id,
            postData["sid"] = this.$store.state.currentUser.sid

            await axios.post(
                this.$store.state.ws_url + "/event/date",
                postData
            ).then(function() {
                s.$emit('resp',{ code: 1, message: 'Data de evento salvo com sucesso' })
            }
            ).catch(function (error) {
                console.log(error);
                toast ({
                    type: VueNotifications.types.error,
                    title: 'Data de Evento',
                    message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
                    timeout: 5000
                })        
            });

        },

        async getEventType() {
          var s = this;
          var currentUser = this.$store.state.currentUser;
          this.isBusy = true;

          await axios.get(
              this.$store.state.ws_url + "/event/type/ddl?companyId=" + this.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function (resp) {
              s.eventTypeDDL = resp.data.obj;
          }
          ).catch(function (error) {
              console.log(error.message);            
          });

          this.isBusy = false;
    
        },
        
        async getFranchiseGroup() {
          var s = this;
          var currentUser = this.$store.state.currentUser;
          this.isBusy = true;

          await axios.get(
              this.$store.state.ws_url + "/franchise/group/ddl?companyId=" + this.companyId + "&isGroup=1&uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function (resp) {
              s.franchiseGroupDDL = resp.data.obj;
          }
          ).catch(function (error) {
              console.log(error.message);            
          });

          this.isBusy = false;
    
        },
    },
    mounted: function() {
        this.getEventType()
        this.getFranchiseGroup()
    }
}
</script>